"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var utils_1 = require("./utils");

var styles_1 = require("./styles");

var FullTableSearchNoResults_1 = require("./FullTableSearchNoResults");

var FullTableToast_1 = require("./FullTableToast");

var FullTableRow_1 = require("./FullTableRow");

var FullTableHeaderRow_1 = require("./FullTableHeaderRow");

var FullTableSearch_1 = require("./FullTableSearch");

var FullTableSelectRowsAction_1 = require("./FullTableSelectRowsAction");

var FullTable =
/** @class */
function (_super) {
  __extends(FullTable, _super);

  function FullTable(props) {
    var _this = _super.call(this, props) || this;

    _this.propsAreValid = function () {
      var rows = _this.props.rows;
      return !rows.some(function (row) {
        return row.sortIndex.length !== row.display.length && row.display.length !== _this.props.headerRow.length;
      });
    };

    _this.performSort = function (cellIndex) {
      var headerRow = _this.props.headerRow;
      var _a = _this.state,
          isDescendingColumn = _a.isDescendingColumn,
          sortedRows = _a.sortedRows;
      var sortByDefault = headerRow[0].sortBy;
      var sortByCurrent = headerRow[cellIndex].sortBy;

      if (!sortByCurrent) {
        return;
      }

      var isAscending = isDescendingColumn[cellIndex];
      sortedRows.sort(function (a, b) {
        return utils_1.sortComparator(utils_1.handleSortBy(a.sortIndex[0], sortByDefault), utils_1.handleSortBy(b.sortIndex[0], sortByDefault), utils_1.handleSortBy(a.sortIndex[cellIndex], sortByCurrent), utils_1.handleSortBy(b.sortIndex[cellIndex], sortByCurrent), isAscending);
      });
      isDescendingColumn.forEach(function (element, index) {
        isDescendingColumn[index] = !(cellIndex === index && isAscending);
      });

      _this.setState({
        sortedRows: sortedRows,
        isDescendingColumn: isDescendingColumn,
        activeSortCell: cellIndex
      });
    };

    _this.isRowSelected = function (row) {
      var search = _this.props.search;
      return search ? row.selected && row.visible : row.selected;
    };

    _this.getCheckboxStatus = function (rows) {
      var rowsSelectedCount = rows.filter(function (row) {
        return _this.isRowSelected(row);
      }).length;
      var rowsCount = rows.filter(function (row) {
        return row.visible;
      }).length;

      if (rowsSelectedCount === rowsCount) {
        return 'ALL';
      }

      return rowsSelectedCount === 0 ? 'NONE' : 'SOME';
    };

    _this.selectRow = function (index) {
      var sortedRows = _this.state.sortedRows;
      sortedRows[index].selected = !_this.isRowSelected(sortedRows[index]);

      var checkboxStatus = _this.getCheckboxStatus(sortedRows);

      _this.setState({
        sortedRows: sortedRows,
        checkboxStatus: checkboxStatus,
        showSelectedToast: checkboxStatus !== 'NONE'
      });
    };

    _this.selectHeaderRow = function () {
      var _a = _this.state,
          checkboxStatus = _a.checkboxStatus,
          sortedRows = _a.sortedRows;
      checkboxStatus = checkboxStatus === 'NONE' ? 'ALL' : 'NONE';
      sortedRows.forEach(function (row) {
        row.selected = checkboxStatus === 'ALL';
      });

      _this.setState({
        checkboxStatus: checkboxStatus,
        sortedRows: sortedRows,
        showSelectedToast: checkboxStatus === 'ALL'
      });
    };

    _this.performSearch = function (value) {
      var sortedRows = _this.state.sortedRows;
      var hasSearchResults = false;
      sortedRows.forEach(function (row) {
        row.visible = utils_1.searchComparator(row.sortIndex[0], value);

        if (row.visible) {
          hasSearchResults = true;
        }
      });

      _this.setState({
        searchValue: value,
        checkboxStatus: _this.getCheckboxStatus(sortedRows),
        sortedRows: sortedRows,
        hasSearchResults: hasSearchResults
      });
    };

    _this.clearSearch = function () {
      _this.performSearch('');
    };

    _this.toastAction = function () {
      var toastAction = _this.props.toastAction;
      if (!toastAction) return;
      var sortedRows = _this.state.sortedRows;
      var selectedRows = sortedRows.filter(function (row) {
        return _this.isRowSelected(row);
      });
      return toastAction(selectedRows);
    };

    _this.buildActionResult = function () {
      var _a = _this.state,
          sortedRows = _a.sortedRows,
          activeSortCell = _a.activeSortCell,
          isDescendingColumn = _a.isDescendingColumn;
      var headerRow = _this.props.headerRow;
      return {
        sortedRows: sortedRows,
        activeSortCell: activeSortCell,
        headerRow: headerRow,
        descending: activeSortCell >= 0 ? isDescendingColumn[activeSortCell] : undefined
      };
    };

    var isDescendingColumn = [];
    var sortedRows = _this.props.rows;

    _this.props.headerRow.forEach(function () {
      isDescendingColumn.push(true);
    });

    sortedRows.forEach(function (row) {
      row.visible = true;
      row.selected = false;
    });
    _this.state = {
      sortedRows: sortedRows,
      isDescendingColumn: isDescendingColumn,
      activeSortCell: -1,
      searchValue: '',
      hasSearchResults: true,
      checkboxStatus: 'NONE',
      showSelectedToast: false
    };
    return _this;
  }

  FullTable.prototype.componentWillMount = function () {
    var sortOnMount = this.props.sortOnMount;

    if (sortOnMount) {
      this.performSort(0);
    }
  };

  FullTable.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        sortedRows = _a.sortedRows,
        hasSearchResults = _a.hasSearchResults,
        showSelectedToast = _a.showSelectedToast,
        searchValue = _a.searchValue,
        checkboxStatus = _a.checkboxStatus,
        activeSortCell = _a.activeSortCell,
        isDescendingColumn = _a.isDescendingColumn;
    var _b = this.props,
        search = _b.search,
        selectRows = _b.selectRows,
        headerRow = _b.headerRow,
        toastActionText = _b.toastActionText,
        actionButton = _b.actionButton;

    if (this.propsAreValid()) {
      return React.createElement("div", __assign({
        className: "table"
      }, styles_1.tableStyle), showSelectedToast && (!search || search && hasSearchResults) ? React.createElement(FullTableToast_1.FullTableToast, {
        sortedRows: sortedRows,
        isRowSelected: this.isRowSelected,
        toastAction: this.toastAction,
        toastActionText: toastActionText,
        selectHeaderRow: this.selectHeaderRow
      }) : null, React.createElement("div", __assign({}, styles_1.actionsStyle), search ? React.createElement(FullTableSearch_1.FullTableSearch, {
        search: search,
        searchValue: searchValue,
        performSearch: this.performSearch,
        clearSearch: this.clearSearch
      }) : null, selectRows ? React.createElement(FullTableSelectRowsAction_1.FullTableSelectRowAction, {
        selectRows: selectRows,
        actionResult: this.buildActionResult()
      }) : null, actionButton), React.createElement(FullTableHeaderRow_1.FullTableHeaderRow, {
        headerRow: headerRow,
        hasSearchResults: hasSearchResults,
        search: search,
        checkboxStatus: checkboxStatus,
        activeSortCell: activeSortCell,
        isDescendingColumn: isDescendingColumn,
        hasSelectRows: !!selectRows,
        selectHeaderRow: this.selectHeaderRow,
        performSort: this.performSort
      }), search && !hasSearchResults ? React.createElement(FullTableSearchNoResults_1.FullTableSearchNoResults, {
        search: search
      }) : null, sortedRows.map(function (row, index) {
        return row.visible ? React.createElement(FullTableRow_1.FullTableRow, {
          key: index,
          row: row,
          index: index,
          hasSelectRows: !!selectRows,
          isRowSelected: _this.isRowSelected,
          selectRow: _this.selectRow
        }) : null;
      }));
    }

    console.error('FullTable: props are invalid');
    return null;
  };

  return FullTable;
}(React.Component);

exports.FullTable = FullTable;